'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _max2 = require('lodash/max');

var _max3 = _interopRequireDefault(_max2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _class;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _utils = require('../utils/');

var utils = _interopRequireWildcard(_utils);

var _constants = require('../utils/constants');

var _options = require('../utils/options');

var _options2 = _interopRequireDefault(_options);

var _selectors = require('./selectors');

var _selectors2 = _interopRequireDefault(_selectors);

var _accessors = require('./accessors');

var _accessors2 = _interopRequireDefault(_accessors);

var _computors = require('./computors');

var _computors2 = _interopRequireDefault(_computors);

var _eauors = require('./eauors');

var _eauors2 = _interopRequireDefault(_eauors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseChart = (0, _selectors2.default)(_class = (0, _computors2.default)(_class = (0, _accessors2.default)(_class = (0, _eauors2.default)(_class = function () {
  function BaseChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    (0, _classCallCheck3.default)(this, BaseChart);

    this.options = (0, _options2.default)(options, el);
    if ((0, _isFunction3.default)(getInitialOptions)) getInitialOptions((0, _cloneDeep3.default)(this.options));
    this.base = _contructor(el, this.options, data, {
      accessors: this.constructor.accessors,
      selectors: this.constructor.selectors,
      computors: this.constructor.computors,
      eauors: this.constructor.eauors
    });
  }

  (0, _createClass3.default)(BaseChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];

      this.options = (0, _options2.default)(options);
      if ((0, _isFunction3.default)(getInitialOptions)) {
        getInitialOptions((0, _cloneDeep3.default)(this.options));
      }
      this.base = _update(el, this.options, data, {
        accessors: this.constructor.accessors,
        selectors: this.constructor.selectors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      });
    }
  }, {
    key: 'destroy',
    value: function destroy(el) {
      _d2.default.selectAll(el).remove();
    }
  }]);
  return BaseChart;
}()) || _class) || _class) || _class) || _class;

exports.default = BaseChart;


function _contructor(el, options, data, ors) {
  //console.info(utils.prefix, 'BaseChart', '_contructor', '>>');

  utils.noElError(el);

  _d2.default.select(el).call(utils.setupElement, 'div', ors.selectors.wrapper).select(utils.selector(ors.selectors.wrapper)).call(utils.setupElement, 'svg:svg', ors.selectors.chart).select(utils.selector(ors.selectors.chart)).call(utils.setupElement, 'svg:g', ors.selectors.base).select(utils.selector(ors.selectors.base));

  if (options.serie.tooltip.display !== _constants.NEVER) {
    //console.info(utils.prefix, 'BaseChart', '_contructor', '--', 'injectTooltip');
    var tooltip = _d2.default.select(document.body).select(utils.selector(ors.selectors.tooltip));

    if ((0, _isNil3.default)((0, _head3.default)((0, _head3.default)(tooltip)))) {
      _d2.default.select(document.body).call(utils.setupElement, 'div', ors.selectors.tooltip);
    }

    _d2.default.select(document.body).select(utils.selector(ors.selectors.tooltip)).call(ors.eauors.tooltipUpdate, options);
  }

  //console.info(utils.prefix, 'BaseChart', '_contructor', '<<');

  return _update(el, options, data, ors);
}

function _update(el, options, data, ors) {
  //console.info(utils.prefix, 'BaseChart', '_update', '>>');

  utils.noElError(el);

  _d2.default.select(el).select(utils.selector(ors.selectors.wrapper)).call(ors.eauors.wrapperUpdate, options.base).select(utils.selector(ors.selectors.chart)).call(ors.eauors.chartUpdate, options.base).select(utils.selector(ors.selectors.base)).call(ors.eauors.containerUpdate, options.base);

  var xScale = ors.computors.xScale((0, _extends3.default)({}, options, { fromBase: true }), data);
  var yScale = ors.computors.yScale(options, data);

  var width = options.base.width;
  var height = options.base.height;

  function showTooltip(options, scales, serie, datum, color) {
    var element = _d2.default.select(document.body).select(utils.selector(ors.selectors.tooltip));

    var _color = color || utils.getOverColor(options, ors.accessors.focusData(datum));
    element.html(options.tooltip.layout(serie, datum, _color));

    var limitX = width;
    var limitY = height;

    function placementEngine(element, _ref) {
      var limitX = _ref.limitX,
          limitY = _ref.limitY;

      var _d3$mouse = _d2.default.mouse(_d2.default.select(el).select(utils.selector(ors.selectors.chart)).node()),
          _d3$mouse2 = (0, _slicedToArray3.default)(_d3$mouse, 2),
          mouseX = _d3$mouse2[0],
          mouseY = _d3$mouse2[1];

      var _d3$mouse3 = _d2.default.mouse(_d2.default.select(document.body).node()),
          _d3$mouse4 = (0, _slicedToArray3.default)(_d3$mouse3, 2),
          absMouseX = _d3$mouse4[0],
          absMouseY = _d3$mouse4[1];

      var _element$node$getBoun = element.node().getBoundingClientRect(),
          width = _element$node$getBoun.width,
          height = _element$node$getBoun.height;

      var left = limitX >= mouseX + width + _constants.TOOLTIP_CURSOR_X_OFFSET || limitX - mouseX >= mouseX ? absMouseX + _constants.TOOLTIP_CURSOR_X_OFFSET : (0, _max3.default)([absMouseX - width - _constants.TOOLTIP_CURSOR_X_OFFSET, 0]);

      var top = limitY >= mouseY + height + _constants.TOOLTIP_CURSOR_Y_OFFSET || limitY - mouseY >= mouseY ? absMouseY + _constants.TOOLTIP_CURSOR_Y_OFFSET : (0, _max3.default)([absMouseY - height - _constants.TOOLTIP_CURSOR_Y_OFFSET, 0]);

      element.style({
        position: 'absolute',
        left: left + 'px',
        top: top + 'px',
        visibility: _constants.VISIBLE,
        "z-index": options.tooltip.zIndex
      });
    };

    placementEngine(element, { limitX: limitX, limitY: limitY });
  }

  function hideTooltip(partial) {
    _d2.default.select(document.body).select(utils.selector(ors.selectors.tooltip)).style({ visibility: _constants.HIDDEN });
  }

  //console.info(utils.prefix, 'BaseChart', '_update', '<<');

  return {
    xScale: xScale,
    yScale: yScale,
    xPivot: ors.computors.xPivot(options, data),
    yPivot: ors.computors.yPivot(options, data),
    hideTooltip: hideTooltip,
    showTooltip: showTooltip
  };
}